__turbopack_context__.v({
  "badge": "WhichBadge-module__Ne3YmW__badge",
});
